"use client";
import { jsx as t } from "react/jsx-runtime";
import * as a from "@radix-ui/react-avatar";
import * as s from "react";
import { cn as m } from "./index15.js";
const o = s.forwardRef(({ className: e, ...l }, r) => /* @__PURE__ */ t(
  a.Root,
  {
    ref: r,
    className: m("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", e),
    ...l
  }
));
o.displayName = a.Root.displayName;
const f = s.forwardRef(({ className: e, ...l }, r) => /* @__PURE__ */ t(
  a.Image,
  {
    ref: r,
    className: m("aspect-square h-full w-full", e),
    ...l
  }
));
f.displayName = a.Image.displayName;
const i = s.forwardRef(({ className: e, ...l }, r) => /* @__PURE__ */ t(
  a.Fallback,
  {
    ref: r,
    className: m(
      "flex h-full w-full items-center justify-center rounded-full bg-surface-raised text-sm font-medium text-text",
      e
    ),
    ...l
  }
));
i.displayName = a.Fallback.displayName;
export {
  o as Avatar,
  i as AvatarFallback,
  f as AvatarImage
};
//# sourceMappingURL=index4.js.map
